import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import '../../assets/css/component/Input.css'

class CheckBox extends Component {
    render() {
            const { label_name, placeholder,type,disabled,check,id, name, value, onChange, onBlur, error } = this.props;

        return (
            <>
                <Form.Group className="mb-2">
                    <Form.Label className='form_label'>{label_name}</Form.Label>
                    <Form.Control
                       type='checkbox'
                       label={label_name}
                       disabled={disabled}
                       checked={check}
                       className='form_check'
                       name={name}
                       id={id}
                       onChange={onChange}
                       onBlur={onBlur}
                    />
                    {error}
                </Form.Group>
            </>
        );
    }
}

export default CheckBox;
